import { styled } from "@health-zelas/delta"

export const InputGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$xxxs',
  margin: '$xxxs 0',

  '& > div': {
    width: '100%'
  },

  '@sm': {
    flexDirection: 'row'
  }
})

export const ButtonGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column-reverse',
  gap: '$xxxs',
  marginTop: '$md',

  '@sm': {
    marginTop: '$lg',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
})

